import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import Compressor from 'compressorjs';
import { InView } from 'react-intersection-observer';
import Toast from '../../../atoms/Toast';
import Modal from '../../../../components/common/Modal';
import './RatingHalfCard.scss';
import { getCookie } from '../../../../components/common/Cookie';
import DesktopRatingProductCard from '../../RatingProductCard';
import RatingFeedBackQA from '../../../molecules/RatingFeedBackQA';
import FeedBackCard from './FeedBackCard';
import Loader from '../../../../components/common/Loader';
import {
  fetchRatingByUser,
  fetchUnratedRatingProducts,
  fetchUserFeedback,
  fetchQuestions,
  submitPhotoReview,
  deleteImageReview
} from '../../../../actions/ratings';
import {
  getFeedBackQuestions,
  getEditFeedBackQuestions,
  getUserRatingData
} from '../../../selectors/ratingSelector';
import { gtmEventPush, segmentEventPush } from '../../../../modules/ga/GTMdatalayer';
import { ModalDataType, QuestionType, ProductDetailsType } from '../types';
import { hideModal } from '../../../../actions/modal';
import { getProperty } from '../../../../modules/ajio-util/properties';
import { getTermNCon } from '../../../../Flags/selectors';
import {
  getPrivacyPolicy,
  getEnableReviewFlag,
  getFileSize,
  getUserConsent,
  getShowReviewProdBtn,
} from '../../../selectors/featureFlagsSelector';
import { replaceWithJioCDN } from '../../../../utils/imageHandling';

type QuestionArrayType = QuestionType[];
interface RatingHalfCardPropsType {
  productRating: number;
  modalData: ModalDataType;
  hideModal: () => void;
  updateModal: (modalName: string, {}) => void;
  questions: QuestionArrayType;
  products: ProductDetailsType[];
  fetchRatingByUser: ({}) => void;
  fetchUnratedRatingProducts: ({}) => void;
  fetchUserFeedback: ({}) => void;
  fetchQuestions: ({}) => void;
  questionsFromEditFeedBack: QuestionArrayType;
  closeModal: (modalName: string) => void;
  submitPhotoReview: ({}) => void;
  deleteImageReview: ({}) => void;
}

interface RatingHalfCardContentPropsType {
  goToFeedBackPage: () => void;
  questions: QuestionArrayType;
  fetchRatingByUser: ({}) => void;
  fetchUnratedRatingProducts: ({}) => void;
  fetchUserFeedback: ({}) => void;
  modalData: ModalDataType;
  questionsFromEditFeedBack: QuestionArrayType;
  fetchQuestions: ({}) => void;
  productRating: number;
  hideModal: () => void;
  updateModal: (modalName: string, {}) => void;
  submitPhotoReview: ({}) => void;
  deleteImageReview: ({}) => void;
}

interface SelectedOptionsType {
  [key: string]: number;
}
interface selectedQATextType {
  [key: string]: {
    question: string;
    option: string;
    title: string;
    questionId: number;
    subQuestionText: string;
    subResponseId: number;
  };
}

const RatingHalfCard = (props: RatingHalfCardPropsType) => {
  const {
    hideModal,
    modalData,
    updateModal,
    questions = [],
    products = [],
    closeModal,
    fetchRatingByUser,
    fetchUnratedRatingProducts,
    fetchUserFeedback,
    fetchQuestions,
    questionsFromEditFeedBack,
    productRating,
    submitPhotoReview,
    deleteImageReview = () => {},
    enableReview,
    fileSizeCompression,
    userConsent,
    privacyPolicy,
    termsConditions
  } = props;
  const { pageToDisplay, sourcePage } = modalData;
  const [displayContent, setDisplayContent] = useState(pageToDisplay);
  const [imageData, setImageData] = useState([]);

  useEffect(() => {
    setDisplayContent(pageToDisplay);
  }, [pageToDisplay]);

  const goToFeedBackPage = () => {
    updateModal('rating-halfcard', {
      state: {
        ...modalData,
        pageToDisplay: 'feedbackCard'
      }
    });
  };

  return (
    <Modal
      ariaLabel="Submit Feedback"
      name="rating-halfcard"
      className="rating-halfcard"
      show
      closeButton
      onClose={hideModal}
      displayContent={displayContent}
    >
      <div className="close-icon">
        <span role="presentation" className="rating-close-icon" onClick={hideModal} />
      </div>
      <div className="model-container">
        <Loader name="ratings-reviews" />
        {displayContent === 'ratingHalfCard' && (
          <RatingHalfCardContent
            modalData={modalData}
            fetchRatingByUser={fetchRatingByUser}
            fetchUnratedRatingProducts={fetchUnratedRatingProducts}
            fetchUserFeedback={fetchUserFeedback}
            hideModal={hideModal}
            fetchQuestions={fetchQuestions}
            questions={questions}
            productRating={productRating}
            questionsFromEditFeedBack={questionsFromEditFeedBack}
            updateModal={updateModal}
            goToFeedBackPage={goToFeedBackPage}
            deleteImageReview={deleteImageReview}
            enableReview={enableReview}
            userConsent={userConsent}
            fileSizeCompression={fileSizeCompression}
            termsConditions={termsConditions}
            privacyPolicy={privacyPolicy}
            submitPhotoReview={submitPhotoReview}
            setReviewAndImageIds={setImageData}
          />
        )}
        {displayContent === 'feedbackCard' && (
          <FeedBackCard
            products={products}
            modalData={modalData}
            updateModal={updateModal}
            hideModal={() => closeModal('rating-halfcard')}
            sourcePage={sourcePage}
            fetchRatingByUser={fetchRatingByUser}
          />
        )}
      </div>
    </Modal>
  );
};

const RatingHalfCardContent = (props: RatingHalfCardContentPropsType) => {
  const {
    goToFeedBackPage,
    questions = [],
    fetchRatingByUser,
    fetchUnratedRatingProducts,
    fetchUserFeedback,
    modalData,
    questionsFromEditFeedBack,
    fetchQuestions,
    productRating = 0,
    hideModal,
    updateModal,
    termsConditions,
    privacyPolicy,
    deleteImageReview,
    submitPhotoReview,
    enableReview,
    showReviewProdBtn,
    fileSizeCompression,
    userConsent,
    setReviewAndImageIds = () => {}
  } = props;
  const {
    productDetails,
    isEditFeedBack = false,
    editFeedBackData = [],
    categoryID = '',
    sourcePage = '',
    pageName = '',
    pageType = '',
    ratingChangeHandler,
    FeedBackSubmitFailedHandler,
    isfromWriteFeedBack,
    isFeedBackSubmitted,
    editFlowQuestions = [],
    updateSubRating,
    reviewData = {},
    updateReviewData,
    isFromFirstFeedBack = false
  } = modalData;
  const {
    brandName = '',
    description = '',
    imageUrl = '',
    productCode = '',
    optionCode = '',
    skuId = '',
    orderId = '',
    brickCode = ''
  } = productDetails || {};

  const [questionWithOptions, setQuestionWithOptions] = useState<QuestionArrayType>([]);
  const [selectedOptions, setSelectedOptions] = useState<SelectedOptionsType>({});
  const [productRatingValue, setProductRatingVaue] = useState(productRating);
  const [apiCallToFetchQuestion, setApiCallToFetchQuestions] = useState(isEditFeedBack);
  const [selectedQAText, setSelectedQAText] = useState<selectedQATextType>({});
  const [cameraDialog, setCameraDialog] = useState(false);
  const fileInputRef = useRef(null);
  const [imageData, setImageData] = useState([]);
  const [text, setText] = useState('');
  const [reviewError, setReviewError] = useState(null);
  const [fileTypeError, setFileTypeError] = useState(null);
  const maxLength = 500;
  const [uploadFailedError, setUploadFailedError] = useState(null);

  function handleChange(event) {
    const { value } = event.target;
    setText(value.slice(0, maxLength));
    setReviewError(null);
  }

  useEffect(() => {
    if (isEditFeedBack && enableReview) {
      const { reviewText = '', reviewId = '' } = reviewData;
      setText(reviewText);
      let updateImagesMeta = [];
      reviewData?.imageMap?.largeSize?.map((item, index) => {
        const reviewObj = {
          index,
          imageId: item.imageId,
          reviewId,
          imgSrc: item.imageUrl,
          imageStatus: item.imageStatus,
          imageStatusReason: item.imageStatusReason,
          parentImageId: item.imageId,
          retry: false
        };
        updateImagesMeta = imageData;
        updateImagesMeta.push(reviewObj);
      });
      setImageData(updateImagesMeta);
    }
  }, [isEditFeedBack]);

  useEffect(() => {
    if (!isEditFeedBack) {
      setQuestionWithOptions(questions);
    }
  }, [questions, isEditFeedBack]);

  useEffect(() => {
    if (
      isEditFeedBack &&
      questionsFromEditFeedBack.length === 0 &&
      apiCallToFetchQuestion &&
      sourcePage !== 'ORDER_DETAILS'
    ) {
      (async () => {
        const response = await fetchQuestions({ categoryID });
        setApiCallToFetchQuestions(false);
      })();
    }
  }, [isEditFeedBack, questionsFromEditFeedBack, apiCallToFetchQuestion, sourcePage]);

  useEffect(() => {
    if (sourcePage === 'ORDER_DETAILS' && editFlowQuestions.length > 0 && isEditFeedBack) {
      setQuestionWithOptions(editFlowQuestions);
    }
  }, [isEditFeedBack, editFlowQuestions, sourcePage]);

  useEffect(() => {
    if (questionsFromEditFeedBack.length > 0 && isEditFeedBack) {
      setQuestionWithOptions(questionsFromEditFeedBack);
    }
  }, [isEditFeedBack, questionsFromEditFeedBack]);

  useEffect(() => {
    if (isEditFeedBack && editFeedBackData.length > 0) {
      const selectedOptionsObject = {};
      editFeedBackData.map(
        ({ questionId, subResponseId }: { questionId: number; subResponseId: number }) => {
          selectedOptionsObject[`${questionId}`] = subResponseId;
        }
      );
      setSelectedOptions(selectedOptionsObject);
    }
  }, [isEditFeedBack, editFeedBackData]);

  useEffect(() => {
    if (editFlowQuestions.length > 0 && isEditFeedBack && editFeedBackData.length > 0) {
      const selectedQATextObject = {};
      editFeedBackData.map(
        ({ questionId, subResponseId }: { questionId: number; subResponseId: number }) => {
          const question = editFlowQuestions?.find(question => question.questionId === questionId);
          const selectedOptionText = question?.responseOptions?.find(
            response => response.id === subResponseId
          );
          selectedQATextObject[`${questionId}`] = {
            question: question?.title,
            option: selectedOptionText?.text,
            title: question?.title,
            questionId,
            subQuestionText: selectedOptionText?.text,
            subResponseId
          };
        }
      );
      setSelectedQAText(selectedQATextObject);
    }
  }, [isEditFeedBack, editFeedBackData, editFlowQuestions]);

  useEffect(() => {
    setReviewAndImageIds(imageData);
  }, [imageData]);

  const optionSelectionHandler = (selectedOption: number, questionId: number) => {
    setSelectedOptions(initial => {
      return {
        ...initial,
        [questionId]: selectedOption
      };
    });
    const question = questionWithOptions?.find(question => question.questionId === questionId);
    const selectedOptionText = question?.responseOptions?.find(
      response => response.id === selectedOption
    );
    setSelectedQAText(initial => {
      return {
        ...initial,
        [questionId]: {
          question: question?.title || '',
          option: selectedOptionText?.text || '',
          title: question?.title,
          questionId,
          subQuestionText: selectedOptionText?.text || '',
          subResponseId: selectedOption
        }
      };
    });
  };

  const onSubmitClickHandler = async () => {
    const filteredDataRetry = imageData?.filter(item => item?.retry === false);
    const isReviewText = text?.length > 0 ? 'text' : null;
    const isImage = filteredDataRetry?.length > 0 ? 'img' : null;
    let submitResponse = {};
    let responseOnSubmit = {};
    if (text?.length === 0 && filteredDataRetry?.length > 0) {
      setReviewError('Please write your review before submitting');
    } else {
      const requestArray = Object.keys(selectedOptions)
        .map(key => {
          return {
            optionCode: optionCode.length !== 0 ? optionCode : skuId,
            productCode: productCode.length !== 0 ? productCode : skuId,
            questionId: +key,
            skuId,
            subResponseId: selectedOptions[key]
          };
        })
        .filter(object => object.subResponseId !== -1);
      const { questionText = '', selectedOptionsText = '' } = Object.values(selectedQAText).reduce(
        (cumulative: { questionText: string; selectedOptionsText: string }, current) => {
          return {
            questionText: `${cumulative.questionText + current?.question},`,
            selectedOptionsText: `${cumulative.selectedOptionsText + current?.option},`
          };
        },
        { questionText: '', selectedOptionsText: '' }
      );
      const updatedQA = Object.values(selectedQAText);
      // gtmEventPush({
      //   event: 'reviews_rating_interactions',
      //   event_category: 'reviews & ratings interactions',
      //   event_action: questionText.length > 100 ? questionText.substring(0, 100) : questionText,
      //   event_label: `submit | ${selectedOptionsText}`,
      //   ...(orderId.length > 0 && { order_id: orderId }),
      //   product_id: skuId,
      //   product_name: description,
      //   ...(brickCode.length > 0 && { product_brick: brickCode }),
      //   page_name: pageName,
      //   page_type: pageType,
      //   store_type: 'ajio'
      // });
      // if(enableReview) {
      // gtmEventPush({
      //     event: 'reviews_rating_interactions',
      //     event_category: 'reviews_rating_interactions',
      //     event_action: `SR - Success| ${questionText.length > 100 ? questionText.substring(0, 100) : questionText}`,
      //     event_label: `${selectedOptionsText}${isSubRating ? isSubRating+',' : ''}${isReviewText ? isReviewText + ',' : ''}${isImage ? isImage : ''}`,
      //     ...(orderId.length > 0 && {order_id: orderId}),
      //     product_id : skuId,
      //     product_name : description,
      //     ...(brickCode.length > 0 && {product_brick: brickCode}),
      //     page_name: pageName,
      //     page_type: pageType,
      //     store_type: 'ajio'
      //     });
      // }

       segmentEventPush({
        event: 'Sub Ratings Collected',        
        order_id: orderId,
        products: [{ product_id: skuId, product_name: description }],
        review_image_count: imageData?.length,
        review_text: text,
        screen_name: pageName,
        sub_rating_value: selectedOptionsText
      })

       responseOnSubmit = await fetchUserFeedback(requestArray);
      if (responseOnSubmit?.statusCode === 200) {
        updateSubRating && updateSubRating(updatedQA);
        await fetchUnratedRatingProducts({});
      } else {
        FeedBackSubmitFailedHandler && FeedBackSubmitFailedHandler();
        hideModal();
      }
      const isSubRating = selectedOptionsText ? 'sub' : null;
      // const isSubRating = selectedOptionsText ? 'sub' : null;

      if (enableReview) {
        if (filteredDataRetry && filteredDataRetry?.length > 0 && text?.length > 0) {
          const reqObj = {
            skuId,
            optionCode,
            reviewText: text
          };
          gtmEventPush({
            event: 'reviews_rating_interactions',
            event_category: 'reviews_rating_interactions',
            event_action: `SR - Success| ${
              questionText.length > 100 ? questionText.substring(0, 100) : questionText
            }`,
            event_label: `submit | ${selectedOptionsText}${isSubRating ? `${isSubRating},` : ''}${
              isReviewText ? `${isReviewText},` : ''
            }${isImage || ''}`,
            ...(orderId.length > 0 && { order_id: orderId }),
            product_id: skuId,
            product_name: description,
            ...(brickCode.length > 0 && { product_brick: brickCode }),
            page_name: pageName,
            page_type: pageType,
            store_type: 'ajio'
          });
          submitResponse = await apiCall(reqObj, null);
        } else if (text?.length === 0 && filteredDataRetry?.length > 0) {
          setReviewError('Please write your review before submitting');
        } else if (filteredDataRetry?.length === 0 && text?.length > 0) {
          const reqObj = {
            skuId,
            optionCode,
            reviewText: text
          };
          gtmEventPush({
            event: 'reviews_rating_interactions',
            event_category: 'reviews_rating_interactions',
            event_action: `SR - Success| ${
              questionText.length > 100 ? questionText.substring(0, 100) : questionText
            }`,
            event_label: `submit | ${selectedOptionsText}${isSubRating ? `${isSubRating},` : ''}${
              isReviewText ? `${isReviewText},` : ''
            }`,
            ...(orderId.length > 0 && { order_id: orderId }),
            product_id: skuId,
            product_name: description,
            ...(brickCode.length > 0 && { product_brick: brickCode }),
            page_name: pageName,
            page_type: pageType,
            store_type: 'ajio'
          });
          // Segment Push event
          segmentEventPush({
            event: 'Review Widget Interaction',
            event_category: 'reviews_rating_interactions',
            event_action: `SR - Success| ${
              questionText.length > 100 ? questionText.substring(0, 100) : questionText
            }`,
            event_label: `submit | ${selectedOptionsText}${isSubRating ? `${isSubRating},` : ''}${
              isReviewText ? `${isReviewText},` : ''
            }`,
            // ...(orderId.length > 0 && { order_id: orderId }),
             products:[{
                product_id: skuId,
                product_name: description,
                ...(brickCode.length > 0 && { product_brick: brickCode }),
                
                product_brand: '',
                product_list_price: '',
                product_mrp: '',
                product_offer_price: '',
                product_quality_subrating: '',
                product_rating: '',
                product_segment: '',
                product_vertical: '',
               
            }],
            avg_ratings_of_reviews: '',
            count_of_people_found_useful: '',
            no_of_ratings_collected: '',
            review_count: '',
            review_with_images: '',
            size_and_fit_subrating: '',
            value_for_money_subrating: '',
            screen_name: pageName,           
            
          });
          submitResponse = await apiCall(reqObj, null);
        } else if (filteredDataRetry.length === 0 && text.length === 0) {
          gtmEventPush({
            event: 'reviews_rating_interactions',
            event_category: 'reviews_rating_interactions',
            event_action: `SR - Success| ${
              questionText.length > 100 ? questionText.substring(0, 100) : questionText
            }`,
            event_label: `submit | ${selectedOptionsText}${isSubRating ? `${isSubRating},` : ''}`,
            ...(orderId.length > 0 && { order_id: orderId }),
            product_id: skuId,
            product_name: description,
            ...(brickCode.length > 0 && { product_brick: brickCode }),
            page_name: pageName,
            page_type: pageType,
            store_type: 'ajio'
          });
        }
        if (submitResponse && submitResponse?.statusCode === 200) {
          let userName = getCookie('un');
          if (isFromFirstFeedBack && updateReviewData) {
            const updatedReview = {};
            updatedReview.reviewId = submitResponse?.reviewId;
            updatedReview.reviewText = text;
            updatedReview.reviewStatus = 'UNDER MODERATION';
            updatedReview.reviewerName = userName || '';
            updatedReview.createdDate = Date.now();
            updatedReview.imageMap = {};
            let updatedThumbnailArray = [];
            let updatedLargeArray = [];
            filteredDataRetry &&
              filteredDataRetry.length > 0 &&
              filteredDataRetry.map(item => {
                const thumbnailObj = {
                  imageId: item.imageId,
                  imageUrl: item.imgSrc,
                  imageStatus: item.imageStatus,
                  imageStatusReason: item.imageStatusReason,
                  parentImageId: item.parentImageId
                };
                const largeObj = {
                  imageId: item.imageId,
                  imageUrl: item.imgSrc,
                  imageStatus: item.imageStatus,
                  imageStatusReason: item.imageStatusReason
                };
                updatedThumbnailArray.push(thumbnailObj);
                updatedLargeArray.push(largeObj);
              });
            updatedReview.imageMap.thumbnail = updatedThumbnailArray;
            updatedReview.imageMap.largeSize = updatedLargeArray;
            updateReviewData(updatedReview);
          }
          if (isEditFeedBack && updateReviewData) {
            const updatedReview = { ...reviewData };
            updatedReview.reviewStatus = 'UNDER MODERATION';
            updatedReview.reviewText = text;
            updatedReview.imageMap = {};
            let updatedThumbnailArray = [];
            let updatedLargeArray = [];
            filteredDataRetry &&
              filteredDataRetry.length > 0 &&
              filteredDataRetry.map(item => {
                const thumbnailObj = {
                  imageId: item.imageId,
                  imageUrl: item.imgSrc,
                  imageStatus: item.imageStatus,
                  imageStatusReason: item.imageStatusReason,
                  parentImageId: item.parentImageId
                };
                const largeObj = {
                  imageId: item.imageId,
                  imageUrl: item.imgSrc,
                  imageStatus: item.imageStatus,
                  imageStatusReason: item.imageStatusReason
                };
                updatedThumbnailArray.push(thumbnailObj);
                updatedLargeArray.push(largeObj);
              });
            updatedReview.imageMap.thumbnail = updatedThumbnailArray;
            updatedReview.imageMap.largeSize = updatedLargeArray;
            updateReviewData(updatedReview);
          }
        } else {
          // updateModal('rating-halfcard', {
          //   state: {
          //     ...modalData,
          //     rating: 0,
          //     isfromWriteFeedBack: true,
          //     isFeedBackSubmitted: false
          //   }
          // });
        }
      }
    }
   
    if (Object.keys(responseOnSubmit).length) {
      if (responseOnSubmit?.statusCode === 200) {
        //if reviews does not get submitted successfully
        if(enableReview && submitResponse && submitResponse?.statusCode === 400){
          updateModal('rating-halfcard', {
            state: {
              ...modalData,
              rating: 0,
              isfromWriteFeedBack: true,
              isFeedBackSubmitted: false
            }
          });
        }else{ goToFeedBackPage();}
      } else {
          FeedBackSubmitFailedHandler && FeedBackSubmitFailedHandler();
          hideModal();
      }
    }
  };

  // const disableSubmitButton =
  //   Object.values(selectedOptions).filter(value => value !== -1).length === 0;

  const ratingClickHandler = async (rating: number) => {
    const response = await fetchRatingByUser({
      sourcePage,
      skuData: skuId,
      rating,
      fetchSubRatingQuestion: true,
      fetchAggRating: false
    });
    gtmEventPush({
      event: 'reviews_rating_interactions',
      event_category: 'reviews & ratings interactions',
      event_action: 'overall rating',
      event_label: rating,
      ...(orderId.length > 0 && { order_id: orderId }),
      product_id: skuId,
      product_name: description,
      ...(brickCode.length > 0 && { product_brick: brickCode }),
      page_name: pageName,
      page_type: pageType,
      store_type: 'ajio'
    });

    // Segment Push Event
    segmentEventPush({
      event: 'Ratings Collected',
      event_category: 'reviews & ratings interactions',
      event_action: 'overall rating',
      //event_label: rating,
      ...(orderId.length > 0 && { order_id: orderId }),
      // ...(brickCode.length > 0 && { product_brick: brickCode }),
      products:[{
        product_id: skuId,
        product_name: description,
      }],    
      rating_value: rating,
      screen_name: pageName,
      // page_type: pageType,
      store_type: 'ajio'
    });

    if (response?.statusCode === 200) {
      setProductRatingVaue(rating);
      ratingChangeHandler && ratingChangeHandler(rating);
      updateModal('rating-halfcard', {
        state: {
          ...modalData,
          rating,
          isfromWriteFeedBack: false,
          isFeedBackSubmitted: true
        }
      });
    } else {
      updateModal('rating-halfcard', {
        state: {
          ...modalData,
          rating: 0,
          isfromWriteFeedBack: true,
          isFeedBackSubmitted: false
        }
      });
    }
  };

  const openCameraDialog = () => {
    setCameraDialog(!cameraDialog);
  };

  const toggleImageGallery = () => {
    if (fileInputRef) {
      fileInputRef?.current?.click();
      gtmEventPush({
        event: 'reviews_rating_interactions',
        event_category: 'reviews_rating_interactions',
        event_action: 'Add a photo',
        event_label: 'select from gallery',
        ...(orderId.length > 0 && { order_id: orderId }),
        product_id: skuId,
        ...(brickCode.length > 0 && { product_brick: brickCode }),
        page_name: pageName,
        product_name: description,
        page_type: pageType,
        store_type: 'ajio'
      });
    }
  };

  const compressFile = file => {
    return new Promise((resolve, reject) => {
      new Compressor(file, {
        quality: 0.6, // Set the image quality to 60%
        success(result) {
          resolve(result); // Resolve the Promise with the compressed file
        },
        error(err) {
          reject(err); // Reject the Promise with the error message
        }
      });
    });
  };

  const handleFileUpload = async event => {
    const filesArr = event.target.files;
    const uploadedFiles = imageData?.filter(item => item?.retry === false).length;
    const files = Array.from(filesArr).slice(0, 5 - uploadedFiles);
    const imgArr = imageData.slice();

    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      let compressedFile = file;
      const fileType = file?.type;
      const fileSize = file?.size;

      if (fileType === 'image/jpeg' || fileType === 'image/png' || fileType === 'image/jpg') {
        if (fileSize > fileSizeCompression) {
          // 1.5MB check
          compressedFile = await compressFile(file);
        }

        const reader = new FileReader();
        reader.readAsDataURL(compressedFile);

        reader.onloadend = () => {
          const imgObj = {
            imgSrc: reader.result,
            imageId: '',
            reviewId: '',
            imageStatus: '',
            imageStatusReason: '',
            parentImageId: '',
            retry: false,
            index: imgArr.length,
            loader: 'progress_bar'
          };
          imgArr.push(imgObj);
          setImageData(imgArr);

          const base64data = reader.result;
          const reqObj = {
            files: base64data,
            skuId,
            reviewText: ''
          };
          apiCall(reqObj, imgObj.index);
        };
      } else {
        setFileTypeError('file type is not jpeg, png, or jpg');
        openCameraDialog();
      }
    }
    openCameraDialog();
  };

  const removeImage = async index => {
    gtmEventPush({
      event: 'reviews_rating_interactions',
      event_category: 'reviews_rating_interactions',
      event_action: 'Add a photo',
      event_label: 'image upload cancel',
      ...(orderId.length > 0 && { order_id: orderId }),
      product_id: skuId,
      ...(brickCode.length > 0 && { product_brick: brickCode }),
      page_name: pageName,
      product_name: description,
      page_type: pageType,
      store_type: 'ajio'
    });
    const removedImage = imageData?.filter(item => item?.index === index)[0];
    const filteredData = imageData?.filter(item => item?.index !== index);
    setImageData(filteredData);
    if (removedImage?.imageId && removedImage?.reviewId) {
      const imageId = removedImage?.imageId;
      const reviewId = removedImage?.reviewId;
      const reqObj = {
        imageId,
        reviewId
      };
      const response = await deleteImageReview(reqObj);
      if (response?.statusCode !== 200) {
        setImageData(prevItems => {
          prevItems.splice(index, 0, removedImage);
          return [...prevItems];
        });
      }
    }
  };

  const retryImageUpload = index => {
    setImageData(prevItems => {
      return prevItems?.map(item => {
        if (item?.index === index) {
          return { ...item, retry: false, loader: 'progress_bar' };
        }
        return item;
      });
    });
    const selectedItem = imageData?.filter(item => item?.index === index)[0];
    const checkRetry = imageData?.filter(item => item?.retry === true);
    if (checkRetry.length === 0) {
      setUploadFailedError(null);
    }
    const reqObj = {
      files: selectedItem?.imgSrc,
      skuId,
      reviewText: ''
    };
    apiCall(reqObj, index);
  };

  const setProgressLoader = (index, loaderState) => {
    setImageData(prevItems => {
      return prevItems?.map(item => {
        if (item?.index === index) {
          return {
            ...item,
            loader: loaderState
          };
        }
        return item;
      });
    });
  };

  const apiCall = async (reqObj: Object, index: Any) => {
    const halfTimer = setTimeout(() => setProgressLoader(index, 'progress_bar half'), 200);
    const resp = await submitPhotoReview(reqObj, false);
    clearTimeout(halfTimer);
    if (resp?.response && resp?.response?.reviewId && resp.statusCode === 200) {
      const apiResp = resp.response;
      if (resp?.response?.imageIds.length === 1) {
        setImageData(prevItems => {
          return prevItems?.map(item => {
            if (item?.index === index) {
              return {
                ...item,
                imageId: apiResp.imageIds[0],
                reviewId: apiResp.reviewId,
                parentImageId: apiResp.imageIds[0],
                loader: 'progress_bar full'
              };
            }
            return item;
          });
        });
        setTimeout(() => setProgressLoader(index, ''), 200);
        gtmEventPush({
          event: 'reviews_rating_interactions',
          event_category: 'reviews_rating_interactions',
          event_action: 'Add a photo',
          event_label: 'image upload success',
          ...(orderId.length > 0 && { order_id: orderId }),
          product_id: skuId,
          ...(brickCode.length > 0 && { product_brick: brickCode }),
          page_name: pageName,
          product_name: description,
          page_type: pageType,
          store_type: 'ajio'
        });
      }
      const retObj = {
        statusCode: 200,
        reviewId: apiResp.reviewId
      };
      return retObj;
    }
    setImageData(prevItems => {
      return prevItems?.map(item => {
        if (item?.index === index) {
          return { ...item, retry: true, loader: '' };
        }
        return item;
      });
    });
    setUploadFailedError('One or more photos were not uploaded. Please try again.');
    const retObj = {
      statusCode: 400,
      reviewId: null
    };
    return retObj;
  };

  const triggerImpresion = inView => {
    return;
    if (inView) {
      gtmEventPush({
        event: 'reviews_rating_interactions',
        event_category: 'reviews_rating_interactions',
        event_action: 'Add a Review',
        event_label: 'submit',
        ...(orderId.length > 0 && { order_id: orderId }),
        product_id: skuId,
        ...(brickCode.length > 0 && { product_brick: brickCode }),
        page_name: pageName,
        product_name: description,
        page_type: pageType,
        store_type: 'ajio'
      });
    }
  };

  return (
    <div className="rating-half-card-content">
      {isfromWriteFeedBack && (
        <DesktopRatingProductCard
          brandName={brandName}
          description={description}
          imageUrl={imageUrl}
          productRating={0}
          displayError={!isFeedBackSubmitted}
          onRatingClickHandler={rating => ratingClickHandler(rating)}
          variant="desktop"
          feedbackCard
          enableReview={enableReview}
          showReviewProdBtn={showReviewProdBtn}
        />
      )}
      {!isfromWriteFeedBack && isFeedBackSubmitted && (
        <>
          <DesktopRatingProductCard
            brandName={brandName}
            description={description}
            imageUrl={imageUrl}
            productRating={productRatingValue}
            onRatingClickHandler={rating => ratingClickHandler(rating)}
            variant="desktop"
            feedbackCard={false}
            enableReview={enableReview}
            showReviewProdBtn={showReviewProdBtn}
          />
          <hr aria-hidden="true" className="line-break" />
          {questionWithOptions.length > 0 && (
            <div className="feedback-qa-container">
              <p className="heading" role='heading' aria-level={2}>Tell us More</p>
              <p className="sub-heading">Shoppers find your ratings very helpful</p>
              <div className="questions-container">
                {questionWithOptions.map((question: QuestionType,index:number) => {
                  return (
                    <div key={question.questionId}>
                      <RatingFeedBackQA
                        variant="desktop"
                        question={question.title}
                        selected={selectedOptions[question.questionId] || ''}
                        options={question.responseOptions}
                        onClickHandler={selectedOption =>
                          optionSelectionHandler(selectedOption, question.questionId)
                        }
                        index={index}
                      />
                    </div>
                  );
                })}
                {enableReview && (
                  <div className="photo-container">
                    <p role="heading" aria-level="3" className="rating-question">Add a photo</p>
                    {imageData && imageData.length > 0 && (
                      <div>
                        <div className="uploaded-image">
                          {imageData &&
                            imageData.map((item,index) => {
                              return !item?.retry || item.loader ? (
                                <div className="article-image-box">
                                  <div className={`${item.loader ? 'image_upload-loader' : ''}`}>
                                    <div className={item.loader ? item.loader : ''} />
                                  </div>
                                  <img className="article-image" src={replaceWithJioCDN(item?.imgSrc)} alt="Article" />
                                  <img
                                    className="article-image-cross"
                                    src={`${getProperty('imageBaseUrl')}/static/img/imageClose.svg`}
                                    alt="Close icon"
                                    role="button"
                                    tabIndex={0}
                                    aria-label={`Remove image ${index + 1}`}
                                    onClick={() => removeImage(item?.index)}
                                  />
                                </div>
                              ) : (
                                <div
                                  role="button"
                                  tabIndex={0}
                                  aria-label={`Retry upload for image ${index + 1}`}
                                  onClick={() => retryImageUpload(item?.index)}
                                  className="article-image-box-opacity"
                                  style={{
                                    backgroundImage: `url(${item?.imgSrc})`,
                                    backgroundSize: 'cover',
                                    backgroundRepeat: 'no-repeat',
                                    backgroundPosition: 'center'
                                  }}
                                >
                                  <img
                                    className="article-image-retry"
                                    src={`${getProperty(
                                      'imageBaseUrl'
                                    )}/static/img/retryImageUpload.svg`}
                                    alt="Retry icon"
                                    aria-hidden="true"
                                    style={{
                                      position: 'absolute',
                                      top: '3px',
                                      right: '5px',
                                      zIndex: '99',
                                      color: 'red'
                                    }}
                                  />
                                  <div
                                    style={{
                                      position: 'absolute',
                                      background: '#fff',
                                      opacity: '0.6',
                                      inset: '0'
                                    }}
                                  />
                                </div>
                              );
                            })}
                          {imageData && imageData.length < 5 && (
                            <>
                              <div
                                tabIndex={0}
                                role="button"
                                aria-label="Upload another image"
                                onClick={toggleImageGallery}
                                className="uploaded-image-add"
                              >
                                +
                              </div>
                              <input
                                type="file"
                                accept="image/*"
                                onChange={handleFileUpload}
                                style={{ display: 'none' }}
                                ref={fileInputRef}
                                multiple
                              />
                            </>
                          )}
                        </div>
                      </div>
                    )}
                    {imageData && imageData.length === 0 && (
                      <div className="image-upload">
                        <span
                          className="capture-image"
                          role="button"
                          tabIndex={0}
                          aria-label="Upload an image"
                          onClick={toggleImageGallery}
                        >
                          <img
                            src={`${getProperty('imageBaseUrl')}/static/img/addCameraDesktop.svg`}
                            alt="Add image icon"
                            aria-hidden="true"
                          />
                          <input
                            type="file"
                            accept="image/*"
                            onChange={handleFileUpload}
                            style={{ display: 'none' }}
                            ref={fileInputRef}
                            multiple
                          />
                        </span>
                        <div className="image-upload-placeholder">
                          <span>A photo speaks more than a hundred words.</span>
                          <span>Add a photo and show the world what you got.</span>
                        </div>
                      </div>
                    )}
                    {uploadFailedError && <p className="review-error" style={{ color: '#c24d4d' }}>
                        {uploadFailedError}</p>}
                  </div>
                )}
                {enableReview && (
                  <div className="review-container">
                    <p role="heading" aria-level="3" className="rating-question">Write your review here</p>
                    <div className="text-area" style={{ position: 'relative' }}>
                      <textarea
                        value={text}
                        onChange={handleChange}
                        maxLength={maxLength}
                        rows={7}
                        cols={30}
                        placeholder="Tell us more about your experience, product quality, material, size and fit, delivery experience and packaging."
                      />
                      <style>
                        {`
                                            textarea::placeholder {
                                                color: #757575;
                                                font-size: 14;
                                            }
                                            `}
                      </style>
                      <div style={{ position: 'absolute', bottom: 5, right: 10 }}>
                        {text.length}/{maxLength}
                      </div>
                    </div>
                    {reviewError && <p className="review-error">{reviewError}</p>}
                  </div>
                )}
              </div>
              {enableReview && userConsent && (
                <div className="user-consent">
                  <span>
                    You are giving AJIO consent to publish and process personal info in accordance
                    with
                  </span>
                  <a href={termsConditions} style={{ color: '#327ca2' }}>
                    T&C
                  </a>
                  <span> and </span>
                  <a href={privacyPolicy} style={{ color: '#327ca2' }}>
                    privacy policy
                  </a>
                </div>
              )}
              <button
                className="rating-card-cta"
                style={{ opacity: reviewError !== null ? '0.25' : '1' }}
                disabled={reviewError !== null}
                onClick={onSubmitClickHandler}
              >
                <InView
                  as="div"
                  threshold={1}
                  triggerOnce
                  onChange={(inView, entry) => triggerImpresion(inView)}
                >
                  <p className="rating-card-cta-text">SUBMIT FEEDBACK</p>
                </InView>
              </button>
            </div>
          )}
        </>
      )}
      {fileTypeError && (
        <Toast message={fileTypeError} position="bottom" visibility={fileTypeError} time={3000} />
      )}
    </div>
  );
};

const mapStateToProps = (state, ownProps) => {
  const { modalData = {} } = ownProps;
  const { productDetails = {} } = modalData;
  const { optionCode = '' } = getUserRatingData(state) || {};
  return {
    ...ownProps,
    questions: (optionCode === productDetails?.skuId && getFeedBackQuestions(state)) || [],
    questionsFromEditFeedBack: getEditFeedBackQuestions(state) || [],
    termsConditions: getTermNCon(state.flags),
    privacyPolicy: getPrivacyPolicy(state),
    enableReview: getEnableReviewFlag(state) === 'ON',
    showReviewProdBtn: getShowReviewProdBtn(state?.flags),
    fileSizeCompression: getFileSize(state),
    userConsent: getUserConsent(state) === 'ON'
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchRatingByUser: (reqObj = {}) => dispatch(fetchRatingByUser(reqObj)),
    fetchUserFeedback: (reqObj = {}) => dispatch(fetchUserFeedback(reqObj)),
    fetchUnratedRatingProducts: (reqObj = {}) => dispatch(fetchUnratedRatingProducts(reqObj)),
    fetchQuestions: (reqObj = []) => dispatch(fetchQuestions(reqObj)),
    closeModal: (name: string) => dispatch(hideModal(name)),
    submitPhotoReview: (reqObj = {}, showLoader) => dispatch(submitPhotoReview(reqObj, showLoader)),
    deleteImageReview: (reqObj = {}) => dispatch(deleteImageReview(reqObj))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(RatingHalfCard);
